import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { CompanyDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-company-container',
  templateUrl: './company-container.component.html',
  styleUrls: ['./company-container.component.scss']
})
export class CompanyContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  companys$: Observable<CompanyDto[]>;
  loading: boolean;
  isLoadingCompany$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingCompany$ = this.gatwayFacade.isLoadingGateway("Company");
    this.companys$ = this.gatwayFacade.loadGateway("Company");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteCompany(deletedValue: any) {
    this.gatwayFacade.remove("Company", deletedValue);
  }


// this method control both the create and update

  onSubmitCompany(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.Companys;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllCompany = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id != null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllCompany.push(pullData[i]);
    }
  }

// check if the addAllCompany array is not empty, then dispatch the data to the store
   if(addAllCompany.length > 0) {
    this.gatwayFacade.add('Company', addAllCompany);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('Company', allUpdates, ['id']);
  }

   }


}
